import { Map } from "immutable";
import { defaultChartColors } from "views/components/visualizations/Colors";
import { eventsDisplayName } from "views/logic/searchtypes/events/EventHandler";
class ColorMapper {
  constructor(colorMap = Map(), colorIndex = -1) {
    this._value = colorMap;
    this._currentDefaultColor = colorIndex;
  }
  _incrementColor() {
    this._currentDefaultColor = (this._currentDefaultColor + 1) % defaultChartColors.length;
  }
  _nextFreeColor() {
    this._incrementColor();
    return defaultChartColors[this._currentDefaultColor];
  }
  get(name, defaultColor) {
    const color = this._value.get(name);
    if (color) {
      if (name !== eventsDisplayName) {
        this._incrementColor();
      }
      return color;
    }
    if (defaultColor) {
      if (name !== eventsDisplayName) {
        this._incrementColor();
      }
      this._value = this._value.set(name, defaultColor);
      return defaultColor;
    }
    const newColor = this._nextFreeColor();
    this._value = this._value.set(name, newColor);
    return newColor;
  }
  set(name, color) {
    this._value = this._value.set(name, color);
  }
  toBuilder() {
    return new Builder(this._value, this._currentDefaultColor);
  }
  static builder() {
    return new Builder();
  }
  static create(value = Map()) {
    return new ColorMapper(value);
  }
}
class Builder {
  constructor(value = Map(), colorIndex = -1) {
    this.value = value;
    this.colorIndex = colorIndex;
  }
  set(name, color) {
    return new Builder(this.value.set(name, color));
  }
  build() {
    return new ColorMapper(this.value, this.colorIndex);
  }
}
export default ColorMapper;
